
<!--
* Wrapper for Ms file field to enable upload functionality using cloud functions
*
* @param {string} uploadFolder - The folder to upload the file to
* @param {boolean} showControls - Whether to show file controls
*
* @fires MsImageUpload#uploadSuccess
* @fires MsImageUpload#deleteClick
-->

<!--
* Fires when image has been successfully uploaded
*
* @event MsImageUpload#uploadSuccess
-->

<!--
* Fires on delete Click
*
* @event MsImageUpload#deleteClick
-->

<template>
  <div>
    <ms-file-field
      :imageUrl="image"
      :defaultImageUrl="image"
      :isProgressing="isProgressing"
      :progress="progress"
      :showControls="shouldShowControls"
      :maxTime="maxTime"
      :retryWait="retryWait"
      :loadingImageSrc="noImagePlaceholder"
      ref="uploadField"
      @input="onInput"
      @cancelClick="onCancel"
      @deleteClick="onDelete"
    />
  </div>
</template>

<script>
  import AppSelect from '@/components/app-select'
  import AppSettings from '@/app-settings.json'
  import MsFileField from '@/components/ms-file-field'
  import Cloud from '@/cloud/cloud'
  // This import loads the firebase namespace along with all its type information.
  import firebase from 'firebase/app'

  export default {
    name: 'MsFileUpload',
    components: {
      MsFileField,
      AppSelect
    },

    props: {
      uploadFolder: {
        type: String,
        required: true
      },
      imageUrl: {
        type: String,
        default: null
      },

      imageUploadedUrl: {
        type: String,
        default: null
      },
      showControls: {
        type: Boolean
      }
    },

    data: function () {
      return {
        image: this.imageUrl,
        storage: firebase.storage(),
        maxTime: AppSettings.imageUpload.maxTime,
        retryWait: AppSettings.imageUpload.retryWait,
        noImagePlaceholder: AppSettings.noImagePlaceholder,
        imageUpload: {
          isProgressing: false,
          progress: 0
        },
        shouldShowControls: this.showControls ? this.showControls : false
      }
    },

    computed: {

      progress: {
        get () {
          return this.imageUpload.progress
        },

        set (progress) {
          this.imageUpload.progress = progress
        }
      },

      isProgressing: {
        get () {
          return this.imageUpload.isProgressing
        },

        set (isProgressing) {
          this.imageUpload.isProgressing = isProgressing
        }
      }
    },

    created () {
    },

    methods: {

      /**
       * attempts to upload image using cloud function
       *
       * @param {Object} event - event of file input
       */
      onInput: function (event) {
        this.originalFileName = event.target.files[0].name
        Cloud.uploadFile(
          this.uploadFolder,
          event.target.files[0],
          this.progressCb,
          this.errorCb,
          this.successCb
        )

        this.shouldShowControls = false
      },

      /**
       * Progress callback from upload image cloud function
       *
       * @param {Object} snapshot - Snapshot of the image upload object
       * @param {number} snapshot.progress - Progress of image upload
       * @param {string} snapshot.name - Name of image upload
       * @param {string} snapshot.state - State of image upload
       */
      progressCb: function (snapshot) {
        if (!this.isProgressing) {
          this.isProgressing = true
        }

        this.progress = snapshot.progress
        this.fileName = snapshot.name
      },

      /**
       * Error callback from upload image cloud function
       *
       * @param {string} error - Error state
       */
      errorCb: function (error) {
        this.isProgressing = false
        console.error(error)
      },

      /**
       * Success callback from upload image cloud function
       * Emits upload success event and attempts to get thumbnail for image
       *
       * @param {string} url - Url of uploaded image
       * @param {string} thumbUrl - Url of where thmubnail image will eventually resolve
       */
      successCb: function (url) {
        this.emitUploadSuccess(url)
        this.image = this.imageUploadedUrl
        this.isProgressing = false
        this.shouldShowControls = true
      },

      // @Todo handle cancel event
      onCancel: function () {
        console.log('Cancel logic')
      },

      /**
       * Emit delete click
       */
      onDelete: function () {
        this.$emit('deleteClick')
        setTimeout(() => {
          this.image = this.imageUrl
          this.shouldShowControls = false
        }, 0)
      },

      /**
       * Emit upload success
       *
       * @param {string} url - Url of uploaded image
       */
      emitUploadSuccess: function (url) {
        this.$emit('uploadSuccess', url, this.originalFileName)
      }
    }
  }
</script>

<style lang="scss">

</style>
